import $ from 'jquery'

// Use the form's successful controls: unchecked means false, and no page field
// carries an old page number into a new preference or sorting condition.
$(document).ready(() => {
  $('[data-brand-product-sort]').on('change', 'input[type="checkbox"], select', function () {
    const form = this.form
    if (form.requestSubmit) {
      form.requestSubmit()
    } else {
      form.submit()
    }
  })
})
